require('./app/core/core');
require('./app/fos_user/fos_user');
require('./app/mountains/mountains');
require('./app/token_users/token_users');
require('./app/profile/profile');
require('./app/search/search');
require('./app/events/events');
require('./app/club/club');
require('./app/page/page');
require('./app/news/news');
require('./app/index/index');
require('./app/discipline/discipline');
require('./app/committee/committee');
require('./app/competition/competition');
require('./app/rank/rank');
require('./app/education/education');
require('./app/project/project');
require('./app/camp/camp');
require('./app/subclub/subclub');
require('./app/blog/blog.controller');
require('./app/insurance/insurance');
require('./cropper/cropping');